import { MenuItem } from "@mcleod/core";
import { AutogenModelUserMenuFavorite, AutogenRowUserMenuFavorite, RowUserMenuFavoriteFields } from "./autogen/AutogenModelUserMenuFavorite";

export class ModelUserMenuFavorite extends AutogenModelUserMenuFavorite<RowUserMenuFavorite> {
    constructor() {
        super(RowUserMenuFavorite);
    }
}

export class RowUserMenuFavorite extends AutogenRowUserMenuFavorite {
    public static createFromMenuItem(menuItem: MenuItem, includeCaptionAndImage = false, additionalProps: Partial<RowUserMenuFavoriteFields> = {}): RowUserMenuFavorite {
        const favoriteItem = new RowUserMenuFavorite({
            path: menuItem.path,
            ...additionalProps
        });
        if (favoriteItem.get("path") == "url")
            favoriteItem.set({ caption: menuItem.caption, params: menuItem.params });
        if (includeCaptionAndImage) {
            favoriteItem.set("caption", menuItem.favoriteCaption ?? menuItem.caption);
            favoriteItem.set("image", menuItem.image);
        }
        return favoriteItem;
    }
}